import React from 'react'
import styled from 'styled-components'
import { containerDefaultStyles } from 'styles/defaults'
import { BRANDS } from './constants'
import Image from '../Image'
import mediaQuery from '../../styles/mediaQuery'
import { gradientBackgroundText } from 'styles/gradients'

const Section = styled.section`
  padding: 30px 0 80px;

  ${mediaQuery.mobile} {
    margin-bottom: 20px;
    padding-bottom: 0;
  }
`

const Container = styled.div`
  ${containerDefaultStyles};
`

const Title = styled.h6`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 50px;
  ${gradientBackgroundText};

  ${mediaQuery.mobile} {
    margin-bottom: 20px;
  }
`

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  & > * {
    min-width: 0;
  }
`

const Column = styled.div`
  flex: 0 0 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  padding: 15px;

  ${mediaQuery.tablet} {
    flex: 0 0 25%;
    height: 70px;
  }
  ${mediaQuery.mobile} {
    flex: 0 0 33%;
    height: 50px;
    padding: 5px;
    order: ${({ orderXs }) => orderXs};
  }
`

const ImageStyled = styled(Image)`
  width: ${({ width }) => `${width}px`};
  max-width: 100%;

  ${mediaQuery.mobile} {
    width: ${({ width }) => `${width / 2}px`};
  }
`

const Index = () => (
  <Section>
    <Container>
      <Title>100s OF YOUR FAVORITE BRANDS</Title>
      <List>
        {BRANDS.map(({ name, width, orderXs, title }) => (
          <Column orderXs={orderXs} key={name}>
            <ImageStyled
              fileName={`brands/${name}.png`}
              width={width}
              alt={title}
              title={title}
            />
          </Column>
        ))}
      </List>
    </Container>
  </Section>
)

export default Index
